<template>
  <div>
    <h1>Lista de Conselheiros</h1>
    <b-card>
      <div class="mb-2 text-right">
        <b-button
          size="sm"
          variant="bagsis"
          :to="{ name: 'conselheiros_create' }"
          v-if="$can('conselheiros:create')"
        >
          <font-awesome-icon icon="plus" />
          Novo
        </b-button>
      </div>
      <div class="d-flex mb-2">
        <table-header-search
          class="mr-auto w-100"
          :search.sync="termo_pesquisa"
          :showAdvancedSearch="false"
          @clear="
            mandato_id = null;
            conselho_id = null;
          "
          @search="loadData"
        >
          <template #append>
            <div class="flex-grow-1 mr-1">
              <select-conselho v-model="conselho_id" add-null-value />
            </div>
            <div class="flex-grow-1 mr-1">
              <select-item-mandato
                v-model="mandato_id"
                :conselho-id="conselho_id"
                add-null-value
              />
            </div>
          </template>
        </table-header-search>
      </div>

      <b-table striped hover :items="conselheiros" :fields="fields" show-empty>
        <template #cell(conselho.nome)="{ item }">
          <div>{{ item.conselho.nome }}</div>
          <div class="text-muted">{{ item.grupo_entidade.nome }}</div>
        </template>
        <template #cell(mandato)="{ item }">
          {{ item.mandato.gestao_ini | format_date("Y") }} -
          {{ item.mandato.gestao_fim | format_date("Y") }}
        </template>
        <template #cell(funcao)="{ item }">
          {{ item.funcao == "titular" ? "Titular" : "Suplente" }}

          <small
            class="d-block"
            v-if="item.funcao == 'suplente' && item.titular"
            >{{ item.titular.pessoa_fisica.nome }}
          </small>
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('conselhos:edit')"
            :view_delete="$can('conselhos:delete')"
            edit_to="conselheiros_edit"
            @delete="delete_conselheiro"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
      </b-table>
    </b-card>

    <pagination-nav
      :pagination="pagination"
      @input="loadData()"
      class="no-gutters mt-3"
    />
  </div>
</template>

<script>
import SelectConselho from "@/modules/conselhos/Components/SelectConselho.vue";
import SelectItemMandato from "@/modules/conselheiros/Components/SelectItemMandato.vue";
import Actions from "@/components/Table/Actions.vue";
import CellContatos from "@/components/Table/CellContatos.vue";
import { slugify } from "@/helpers/functions/slugify";
import TableHeaderSearch from "@/components/Table/TableHeaderSearch.vue";

import { mapState, mapActions } from "vuex";

export default {
  components: {
    Actions,
    CellContatos,
    SelectConselho,
    SelectItemMandato,
    TableHeaderSearch,
  },
  data: () => ({
    page: 1,
    termo_pesquisa: "",
    conselho_id: null,
    mandato_id: null,
    sortBy: "created_at",
    sortDesc: true,
  }),
  computed: {
    ...mapState("conselheiros", ["conselheiros", "pagination"]),
    fields() {
      return [
        { key: "actions", label: "", class: "cell-actions" },
        { key: "id", label: "#", class: "col-1" },
        { key: "pessoa_fisica.nome", label: "Nome", class: "table-truncate" },
        { key: "conselho.nome", label: "Conselho", class: "table-truncate" },
        { key: "mandato", label: "Mandato" },
        { key: "funcao", label: "Função" },
      ];
    },
    formatedTermoPesquisa() {
      return slugify(this.termo_pesquisa);
    },
  },
  methods: {
    ...mapActions("conselheiros", ["ActionGetAll", "ActionDelete"]),
    async delete_conselheiro(conselheiro) {
      try {
        await this.ActionDelete(conselheiro.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger",
        });
      }
    },
    async loadData() {
      try {
        const payload = {
          page: this.pagination.current_page,
          per_page: this.pagination.per_page,
          orderBy: this.sortBy,
          sortBy: this.sortDesc ? "desc" : "asc",
          q: this.formatedTermoPesquisa,
        };

        if (this.conselho_id) {
          payload["conselho_id"] = this.conselho_id;
        }

        if (this.mandato_id) {
          payload["mandato_id"] = this.mandato_id;
        }

        await this.ActionGetAll(payload);
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.pagination.current_page = this.$route.query.page;
    }
    this.loadData();
  },
};
</script>

<style>
.table-truncate {
  white-space: normal !important;
}
</style>
